import React from 'react';
import { Chart } from 'react-google-charts';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import {
	getInnerDisplayFirstRowConfigForMotorace,
	getOuterDisplayConfig,
	getChartQtyForMotorace,
	chartOptionsForMotorace,
	LoanSummary,
	displayTurnaroundTime,
} from '../cardStatusDisplayConfig';

type Props = {
	loanSummary: LoanSummary;
	groupSelections: number[];
};

const LoanChartForWheeltek = ({ loanSummary, groupSelections }: Props) => {
	const user: {
		branch_name: string;
	} = JSON.parse(localStorage.getItem('tvsd.los.user'));

	return (
		<div>
			<HeaderText>{user?.branch_name} Applications
			<TurnAroundTimeText>
							Turnaround Time:{" "}
							{loanSummary?.turnaround_time
								? displayTurnaroundTime(loanSummary.turnaround_time)
								: "-"}
						</TurnAroundTimeText>
			</HeaderText>
			<ChartContainer>
				<div
					className='ChartContainer'
					style={{
						width: '40%',
						marginTop: '-4.5%',
						marginLeft: '-5%',
						border: 'transparent',
					}}>
					<Chart
						chartType='PieChart'
						options={chartOptionsForMotorace}
						data={getChartQtyForMotorace(loanSummary)}
						width={'85%'}
						height={'300px'}
					/>
				</div>
				<ChartHeadingWrapper>
					<ChartHeading>
						{getInnerDisplayFirstRowConfigForMotorace(loanSummary).map((d, idx) => {
							return (
								<Link
									key={idx.toString()}
									to={{
										pathname: d.pathname,
										state: {
											applicationstatus: d.applicationstatus,
											groupSelections,
										},
									}}
									style={{
										textDecoration: 'none',
										width: '33%',
									}}>
									<ChatTitle>
										<span style={{ color: '#333333' }}>
											<img src={d.img} alt='refresh' width={24} height={24} /> {d.label}
										</span>
										<CountText>{d.qty}</CountText>
									</ChatTitle>
								</Link>
							);
						})}
					</ChartHeading>
				</ChartHeadingWrapper>
			</ChartContainer>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginTop: '3%',
					width: '100%',
					marginBottom: '5%',
				}}>
				{getOuterDisplayConfig(loanSummary).map((d, idx) => {
					return (
						<StatusContainer key={idx.toString()}>
							<Link
								to={{
									pathname: d.pathname,
									state: {
										applicationstatus: d.applicationstatus,
										groupSelections,
									},
								}}>
								<ApplicationStatus>{d.label}</ApplicationStatus>
								<ApplicationCount>{d.qty}</ApplicationCount>
							</Link>
						</StatusContainer>
					);
				})}
			</div>
		</div>
	);
};

const HeaderText = styled.div`
	font-weight: 400;
	line-height: 22px;
	text-align: left;
	color: #2a2a3e;
	margin-top: 2%;
`;

const ChartContainer = styled.div`
	display: flex;
	width: 100%;
	height: 25vh;
	padding: 24px 16px 24px 16px;
	border-radius: 8px;
	background: #f2f3ff;
	margin-right: 1%;
	margin-top: 1%;
	background: var(--primary-50-f-2-f-3-ff, #f2f3ff);
	@media only screen and (max-width: 1688px) {
		height: 27vh;
	}
`;

const ChartHeadingWrapper = styled.div`
	width: 60%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

const ChartHeading = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	text-allign: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px;
`;

const ChatTitle = styled.div`
	display: flex;
	flex-direction: column;
`;

const CountText = styled.h3`
	color: var(--primary-6956-ba, #6956ba);
	font-family: Noto Sans;
	font-size: 28px;
	font-style: normal;
	font-weight: 700;
	line-height: 36px;
	margin-left: 1.7rem;
`;

const StatusContainer = styled.div`
	display: flex;
	flex-direction: column;
	text-align: left;
	align-items: flex-start;
	border-radius: 8px;
	background: var(--primary-100-dde-0-ff, #dde0ff);
	height: 96px;
	padding: 8px 16px;
	width: 23.5%;
	justify-content: center;
`;

const ApplicationStatus = styled.div`
	color: var(--grey-5333333, #333);
	/* Body 14pts */
	font-family: Noto Sans;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px; /* 128.571% */
`;

const ApplicationCount = styled.div`
	color: var(--primary-6956-ba, #6956ba);
	/* H3 Heading 28pts */
	font-family: Noto Sans;
	font-size: 28px;
	font-style: normal;
	font-weight: 700;
	line-height: 36px; /* 128.571% */
`;

const TurnAroundTimeText = styled.div`
	font-family: Inter;
	font-size: 12px;
	line-height: 17px;
	text-align: left;
	font-weight: 400;
	margin-top: 5px;
	vertical-align: middle;
	color: #566a89;
	:hover {
		cursor: default;
	}
`;


export default LoanChartForWheeltek;
